// src/utils/create-split-props.ts
import { splitProps } from "solid-js";
var createSplitProps = () => (props, keys) => splitProps(props, keys);

export {
  createSplitProps
};
